module.exports = __webpack_public_path__ + "static/img/main.1f40d4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/13/main.png
// module id = Z/9s
// module chunks = 1